import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
  selector: '[gcUserButton]'
})

export class UserButtonDirective {
  constructor(public template: TemplateRef<any>) {}
  @Input() onTheRight = true;
  @Input() param: string;

}

